/*undefined*/
"use strict";

var $protobuf = require("protobufjs/minimal");

// Common aliases
var $Reader = $protobuf.Reader, $Writer = $protobuf.Writer, $util = $protobuf.util;

// Exported root namespace
var $root = $protobuf.roots["default"] || ($protobuf.roots["default"] = {});

$root.SalesAnalysisFilter = (function() {

    /**
     * Namespace SalesAnalysisFilter.
     * @exports SalesAnalysisFilter
     * @namespace
     */
    var SalesAnalysisFilter = {};

    SalesAnalysisFilter.SalesAnalysisFilterModel = (function() {

        /**
         * Properties of a SalesAnalysisFilterModel.
         * @memberof SalesAnalysisFilter
         * @interface ISalesAnalysisFilterModel
         * @property {string|null} [dateFrom] SalesAnalysisFilterModel dateFrom
         * @property {string|null} [dateTo] SalesAnalysisFilterModel dateTo
         * @property {string|null} [clientName] SalesAnalysisFilterModel clientName
         * @property {string|null} [assetId] SalesAnalysisFilterModel assetId
         * @property {string|null} [sortColumn] SalesAnalysisFilterModel sortColumn
         * @property {string|null} [sortOrder] SalesAnalysisFilterModel sortOrder
         * @property {number|null} [pageIndex] SalesAnalysisFilterModel pageIndex
         * @property {number|null} [pageSize] SalesAnalysisFilterModel pageSize
         */

        /**
         * Constructs a new SalesAnalysisFilterModel.
         * @memberof SalesAnalysisFilter
         * @classdesc Represents a SalesAnalysisFilterModel.
         * @implements ISalesAnalysisFilterModel
         * @constructor
         * @param {SalesAnalysisFilter.ISalesAnalysisFilterModel=} [p] Properties to set
         */
        function SalesAnalysisFilterModel(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * SalesAnalysisFilterModel dateFrom.
         * @member {string|null|undefined} dateFrom
         * @memberof SalesAnalysisFilter.SalesAnalysisFilterModel
         * @instance
         */
        SalesAnalysisFilterModel.prototype.dateFrom = null;

        /**
         * SalesAnalysisFilterModel dateTo.
         * @member {string|null|undefined} dateTo
         * @memberof SalesAnalysisFilter.SalesAnalysisFilterModel
         * @instance
         */
        SalesAnalysisFilterModel.prototype.dateTo = null;

        /**
         * SalesAnalysisFilterModel clientName.
         * @member {string|null|undefined} clientName
         * @memberof SalesAnalysisFilter.SalesAnalysisFilterModel
         * @instance
         */
        SalesAnalysisFilterModel.prototype.clientName = null;

        /**
         * SalesAnalysisFilterModel assetId.
         * @member {string|null|undefined} assetId
         * @memberof SalesAnalysisFilter.SalesAnalysisFilterModel
         * @instance
         */
        SalesAnalysisFilterModel.prototype.assetId = null;

        /**
         * SalesAnalysisFilterModel sortColumn.
         * @member {string|null|undefined} sortColumn
         * @memberof SalesAnalysisFilter.SalesAnalysisFilterModel
         * @instance
         */
        SalesAnalysisFilterModel.prototype.sortColumn = null;

        /**
         * SalesAnalysisFilterModel sortOrder.
         * @member {string|null|undefined} sortOrder
         * @memberof SalesAnalysisFilter.SalesAnalysisFilterModel
         * @instance
         */
        SalesAnalysisFilterModel.prototype.sortOrder = null;

        /**
         * SalesAnalysisFilterModel pageIndex.
         * @member {number|null|undefined} pageIndex
         * @memberof SalesAnalysisFilter.SalesAnalysisFilterModel
         * @instance
         */
        SalesAnalysisFilterModel.prototype.pageIndex = null;

        /**
         * SalesAnalysisFilterModel pageSize.
         * @member {number|null|undefined} pageSize
         * @memberof SalesAnalysisFilter.SalesAnalysisFilterModel
         * @instance
         */
        SalesAnalysisFilterModel.prototype.pageSize = null;

        // OneOf field names bound to virtual getters and setters
        var $oneOfFields;

        /**
         * SalesAnalysisFilterModel _dateFrom.
         * @member {"dateFrom"|undefined} _dateFrom
         * @memberof SalesAnalysisFilter.SalesAnalysisFilterModel
         * @instance
         */
        Object.defineProperty(SalesAnalysisFilterModel.prototype, "_dateFrom", {
            get: $util.oneOfGetter($oneOfFields = ["dateFrom"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * SalesAnalysisFilterModel _dateTo.
         * @member {"dateTo"|undefined} _dateTo
         * @memberof SalesAnalysisFilter.SalesAnalysisFilterModel
         * @instance
         */
        Object.defineProperty(SalesAnalysisFilterModel.prototype, "_dateTo", {
            get: $util.oneOfGetter($oneOfFields = ["dateTo"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * SalesAnalysisFilterModel _clientName.
         * @member {"clientName"|undefined} _clientName
         * @memberof SalesAnalysisFilter.SalesAnalysisFilterModel
         * @instance
         */
        Object.defineProperty(SalesAnalysisFilterModel.prototype, "_clientName", {
            get: $util.oneOfGetter($oneOfFields = ["clientName"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * SalesAnalysisFilterModel _assetId.
         * @member {"assetId"|undefined} _assetId
         * @memberof SalesAnalysisFilter.SalesAnalysisFilterModel
         * @instance
         */
        Object.defineProperty(SalesAnalysisFilterModel.prototype, "_assetId", {
            get: $util.oneOfGetter($oneOfFields = ["assetId"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * SalesAnalysisFilterModel _sortColumn.
         * @member {"sortColumn"|undefined} _sortColumn
         * @memberof SalesAnalysisFilter.SalesAnalysisFilterModel
         * @instance
         */
        Object.defineProperty(SalesAnalysisFilterModel.prototype, "_sortColumn", {
            get: $util.oneOfGetter($oneOfFields = ["sortColumn"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * SalesAnalysisFilterModel _sortOrder.
         * @member {"sortOrder"|undefined} _sortOrder
         * @memberof SalesAnalysisFilter.SalesAnalysisFilterModel
         * @instance
         */
        Object.defineProperty(SalesAnalysisFilterModel.prototype, "_sortOrder", {
            get: $util.oneOfGetter($oneOfFields = ["sortOrder"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * SalesAnalysisFilterModel _pageIndex.
         * @member {"pageIndex"|undefined} _pageIndex
         * @memberof SalesAnalysisFilter.SalesAnalysisFilterModel
         * @instance
         */
        Object.defineProperty(SalesAnalysisFilterModel.prototype, "_pageIndex", {
            get: $util.oneOfGetter($oneOfFields = ["pageIndex"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * SalesAnalysisFilterModel _pageSize.
         * @member {"pageSize"|undefined} _pageSize
         * @memberof SalesAnalysisFilter.SalesAnalysisFilterModel
         * @instance
         */
        Object.defineProperty(SalesAnalysisFilterModel.prototype, "_pageSize", {
            get: $util.oneOfGetter($oneOfFields = ["pageSize"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Encodes the specified SalesAnalysisFilterModel message. Does not implicitly {@link SalesAnalysisFilter.SalesAnalysisFilterModel.verify|verify} messages.
         * @function encode
         * @memberof SalesAnalysisFilter.SalesAnalysisFilterModel
         * @static
         * @param {SalesAnalysisFilter.ISalesAnalysisFilterModel} m SalesAnalysisFilterModel message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SalesAnalysisFilterModel.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.dateFrom != null && Object.hasOwnProperty.call(m, "dateFrom"))
                w.uint32(10).string(m.dateFrom);
            if (m.dateTo != null && Object.hasOwnProperty.call(m, "dateTo"))
                w.uint32(18).string(m.dateTo);
            if (m.clientName != null && Object.hasOwnProperty.call(m, "clientName"))
                w.uint32(26).string(m.clientName);
            if (m.assetId != null && Object.hasOwnProperty.call(m, "assetId"))
                w.uint32(34).string(m.assetId);
            if (m.sortColumn != null && Object.hasOwnProperty.call(m, "sortColumn"))
                w.uint32(42).string(m.sortColumn);
            if (m.sortOrder != null && Object.hasOwnProperty.call(m, "sortOrder"))
                w.uint32(50).string(m.sortOrder);
            if (m.pageIndex != null && Object.hasOwnProperty.call(m, "pageIndex"))
                w.uint32(56).int32(m.pageIndex);
            if (m.pageSize != null && Object.hasOwnProperty.call(m, "pageSize"))
                w.uint32(64).int32(m.pageSize);
            return w;
        };

        /**
         * Encodes the specified SalesAnalysisFilterModel message, length delimited. Does not implicitly {@link SalesAnalysisFilter.SalesAnalysisFilterModel.verify|verify} messages.
         * @function encodeDelimited
         * @memberof SalesAnalysisFilter.SalesAnalysisFilterModel
         * @static
         * @param {SalesAnalysisFilter.ISalesAnalysisFilterModel} message SalesAnalysisFilterModel message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SalesAnalysisFilterModel.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a SalesAnalysisFilterModel message from the specified reader or buffer.
         * @function decode
         * @memberof SalesAnalysisFilter.SalesAnalysisFilterModel
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {SalesAnalysisFilter.SalesAnalysisFilterModel} SalesAnalysisFilterModel
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SalesAnalysisFilterModel.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.SalesAnalysisFilter.SalesAnalysisFilterModel();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.dateFrom = r.string();
                    break;
                case 2:
                    m.dateTo = r.string();
                    break;
                case 3:
                    m.clientName = r.string();
                    break;
                case 4:
                    m.assetId = r.string();
                    break;
                case 5:
                    m.sortColumn = r.string();
                    break;
                case 6:
                    m.sortOrder = r.string();
                    break;
                case 7:
                    m.pageIndex = r.int32();
                    break;
                case 8:
                    m.pageSize = r.int32();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        /**
         * Decodes a SalesAnalysisFilterModel message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof SalesAnalysisFilter.SalesAnalysisFilterModel
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {SalesAnalysisFilter.SalesAnalysisFilterModel} SalesAnalysisFilterModel
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SalesAnalysisFilterModel.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        return SalesAnalysisFilterModel;
    })();

    return SalesAnalysisFilter;
})();

module.exports = $root;
